"use client";

import { CheckCircle } from "lucide-react";
import { Card, CardContent } from "../card";
import { Button } from "../button";

interface BookingSuccessProps {
  onReset: () => void;
  eventId?: string;
}

export function BookingSuccess({ onReset, eventId }: BookingSuccessProps) {
  return (
    <Card className="border-green-200 bg-green-50">
      <CardContent className="pt-6">
        <div className="text-center">
          <CheckCircle className="h-16 w-16 mx-auto mb-4 text-green-600" />
          <h3 className="text-lg font-semibold text-green-800 mb-2">
            Meeting Booked Successfully!
          </h3>
          <p className="text-green-700 mb-4">
            Your meeting has been scheduled and you should receive a calendar invitation shortly.
          </p>
          {eventId && (
            <p className="text-sm text-green-600 mb-4">
              Event ID: {eventId}
            </p>
          )}
          <Button onClick={onReset} variant="outline" className="border-green-300 text-green-700 hover:bg-green-100">
            Book Another Meeting
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
